import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CmsConfig, I18nModule, provideConfig } from '@spartacus/core';
import { CustomTrustedShopsWidgetModule } from '../custom-truestedshops-widget/custom-trustedshops-widget.module';
import { CustomStoreReviewsCarouselComponent } from './custom-store-reviews-carousel.component';

@NgModule({
  declarations: [CustomStoreReviewsCarouselComponent],
  imports: [CommonModule, I18nModule, CustomTrustedShopsWidgetModule],
  providers: [
    provideConfig(<CmsConfig>{
      cmsComponents: {
        StoreReviewsCarouselTrustedShopsComponent: {
          component: CustomStoreReviewsCarouselComponent,
        },
      },
    }),
  ],
})
export class CustomStoreReviewsCarouselModule {}
